import { WordRotate } from "@/components/ui/word-rotate";
import { motion } from "motion/react";

interface HeroProps {
  setIsContactModalOpen?: (open: boolean) => void;
}

export default function Hero({ setIsContactModalOpen }: HeroProps) {
  const rotatingWords = ["Art", "Tech", "Impact"];

  return (
    <section
      id="hero"
      className="kivas-hero relative w-full flex items-center overflow-hidden"
    >
      <div
        className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center pt-10 md:pt-14 pb-8"
      >
        <div
          className="flex flex-col items-center text-center pointer-events-none w-full mx-auto"
        >
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.1 }}
            className="mb-8"
          >
            <span className="inline-block overflow-hidden">
              <motion.span
                initial={{ y: 80, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.2,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="inline-block font-Montserrat text-5xl md:text-7xl lg:text-[96px] xl:text-[104px] font-bold tracking-tight text-black dark:text-white"
              >
                EXPERIENCE
              </motion.span>
            </span>
            <br />
            <span className="flex flex-nowrap items-baseline justify-center">
              <motion.span
                initial={{ y: 80, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.4,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="inline-block font-Montserrat text-5xl md:text-7xl lg:text-[96px] xl:text-[104px] font-bold tracking-tight leading-none text-black dark:text-white mr-[0.15em]"
              >
              
              </motion.span>
              <motion.span
                initial={{ y: 80, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.4,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="inline-block"
              >
                <WordRotate
                  words={rotatingWords}
                  duration={2000}
                  className="inline-block italic font-serif font-bold text-6xl md:text-8xl lg:text-[120px]
                  xl:text-[130px] leading-none text-transparent bg-clip-text bg-linear-to-r from-black dark:from-white via-indigo-600 dark:via-indigo-200 to-indigo-500/50 pr-2"
                />
              </motion.span>
            </span>
          </motion.h1>

          <div className="max-w-md flex flex-col gap-2 items-center text-center">
            <motion.span
              initial={{ y: 80, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.8,
                delay: 0.6,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="font-Montserrat text-lg md:text-xl font-light text-black/60 dark:text-white/60"
            >
              Designed to upgrade your vision
            </motion.span>
            <motion.span
              initial={{ y: 80, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="font-Montserrat text-lg md:text-xl font-light text-black/60 dark:text-white/60"
            >
              Built to fast-track your success
            </motion.span>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12
  pointer-events-auto w-full sm:w-auto"
          >
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              onClick={() => setIsContactModalOpen?.(true)}
              className="interactive font-Montserrat text-xs font-semibold uppercase tracking-widest bg-black dark:bg-white text-white dark:text-black px-8 py-4 rounded-full hover:opacity-90 active:scale-[0.97] transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] w-full sm:w-auto shadow-xl shadow-black/10 cursor-pointer"
            >
              Start a Project
            </motion.button>
            <a href="/work" className="w-full sm:w-auto">
              <motion.button
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                className="interactive font-Montserrat text-xs font-semibold uppercase tracking-widest border border-black/20 dark:border-white/20 px-8 py-4 rounded-full hover:bg-black/5 dark:hover:bg-white/5 active:scale-[0.97] transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] text-black dark:text-white w-full sm:w-auto"
              >
                Our Work
              </motion.button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
